export default "__VITE_ASSET__f5807edc__"